<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-success m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <p class="h3 text-dark">Out of Station (Corridor) Manager</p>
            </div>
          </div>
        </div>
      </div>

      <section
        class=""
        v-if="
          user.user_role == 1 ||
          user.job_title == 'Claims Vetter' ||
          user.job_title == 'Claims Verifier' ||
          user.type == 'shis'
        "
      >
        <div class="container">
          <div class="row list">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-header">
                  <p class="h5">Filter Corridor Requests</p>
                </div>
                <div class="card-body">
                  <div class="">
                    <form @submit.prevent="getCodesAgency">
                      <div class="row">
                        <div class="form-group col-md-6">
                          <label>Select SHIA </label>
                          <select class="form-control" v-model="query.state">
                            <option
                              :value="state"
                              v-for="state in states"
                              :key="state"
                            >
                              {{ state.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group col-md-6">
                          <label>Select Status </label>
                          <v-select
                            v-model="query.status"
                            label="agency_name"
                            :options="statuses"
                          />
                        </div>

                        <div class="form-group col-md-5">
                          <label for="inputCity"
                            ><i class="fe fe-calendar"></i> Start Date
                          </label>
                          <input
                            type="date"
                            class="form-control"
                            v-model="query.from"
                          />
                        </div>

                        <div class="form-group col-md-5">
                          <label for="inputCity"
                            ><i class="fe fe-calendar"></i> End Date
                          </label>
                          <input
                            type="date"
                            class="form-control"
                            v-model="query.to"
                          />
                        </div>

                        <div class="col-md-2 form-group">
                          <label for="">Rows</label>
                          <select
                            class="form-control"
                            v-model="query.paginate_value"
                          >
                            <option>30</option>
                            <option>100</option>
                            <option>500</option>
                            <option>1000</option>
                            <option>2000</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <button type="submit" class="btn btn-success btn-block">
                          Filter
                        </button>

                        <button class="btn btn-outline-dark my-2 btn-block">
                          <download-excel
                            :data="codes.data"
                            :fields="json_fields"
                            type="xls"
                            :escapeCsv="false"
                            :name="'Corridor_data' + '.xls'"
                          >
                          </download-excel>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="">
        <div class="container">
          <div class="row list">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <p class="h5">{{ codes.total }} Out of State Requests</p>

                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Date Requested</th>
                          <th>Enrollee SHIA</th>
                          <th>Out of Station SHIA</th>
                          <th>Enrollee</th>
                          <th>Facility</th>
                          <th>Status</th>
                          <th
                            v-if="
                              user.type == 'shis' || user.type == 'employee'
                            "
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="diag in codes.data" v-bind:key="diag.id">
                          <td>
                            {{ diag.date_requested }}
                            <span class="text-primary">
                              {{ diag.created_at | moment("from", "now") }}
                            </span>
                          </td>

                          <td>
                            <span v-if="diag.agency != null"> </span>
                            {{ diag.agency.agency_name }}
                          </td>

                          <td>
                            <span
                              v-if="diag.recipientfacility.provider != null"
                            >
                              {{
                                diag.recipientfacility.provider.agency
                                  .agency_name
                              }}
                            </span>
                          </td>
                          <td>
                            <span v-if="diag.enrollee">{{
                              diag.enrollee.full_name
                            }}</span>
                          </td>

                          <td>
                            <span v-if="diag.recipientfacility != null">{{
                              diag.recipientfacility.agency_name
                            }}</span>
                          </td>

                          <td>
                            <button
                              type="button"
                              class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark spacer"
                            >
                              {{ diag.status }}
                            </button>
                          </td>
                          <td>
                            <button
                              class="btn btn-outline-dark"
                              data-toggle="modal"
                              @click="getCode(diag)"
                              data-target="#slideRightModalAll"
                            >
                              <i class="fe fe-eye"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="text-center">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="codes.total"
                        :per-page="codes.per_page"
                        aria-controls="my-table"
                        @input="getCodes(currentPage ? currentPage : 1)"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal -->
          <div
            class="modal fade modal-slide-right"
            id="slideRightModalAll"
            tabindex="-1"
            role="dialog"
            aria-labelledby="slideRightModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content" id="printDiv" ref="printNow">
                <div class="modal-header">
                  <p class="modal-title" id="slideRightModalLabel">
                    <span class="h5">Out of Station Request</span>
                  </p>

                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body" v-if="auth_code">
                  <div class="">
                    <p class="my-2">
                      <b>Status</b>

                      <button
                        v-if="auth_code.status == 'approved'"
                        type="button"
                        class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                      >
                        approved
                      </button>

                      <button
                        v-if="auth_code.status == 'rejected'"
                        type="button"
                        class="btn m-b-15 ml-2 mr-2 badge badge-soft-danger"
                      >
                        rejected
                      </button>

                      <button
                        v-if="auth_code.status == 'pending'"
                        type="button"
                        class="btn m-b-15 ml-2 mr-2 badge badge-soft-warning spacer"
                      >
                        pending
                      </button>
                    </p>

                    <p class="my-2">
                      <b>Approval Code</b> {{ auth_code.code_created }}
                    </p>
                    <p class="my-2">
                      <b>Enrollee Name</b> {{ auth_code.enrollee.full_name }}
                    </p>

                    <p class="my-2">
                      <b>Enrollee ID</b> {{ auth_code.enrollee.id_card_number }}
                    </p>

                    <p class="my-2">
                      <b>Enrollee Plan</b> {{ auth_code.enrollee.sector }}
                    </p>

                    <p class="my-2">
                      <b> Enrollee SHIA </b>
                      {{ auth_code.agency.agency_name }}
                    </p>
                    <p class="my-2">
                      <b>Out of Station SHIA</b>
                      {{
                        auth_code.recipientfacility.provider.agency.agency_name
                      }}
                    </p>
                    <p class="my-2">
                      <b> Out of Station Facility</b>
                      {{ auth_code.recipientfacility.agency_name }}
                    </p>

                    <p class="my-2">
                      <b> Date Requested</b>
                      {{
                        auth_code.created_at
                          | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                      }}
                    </p>
                  </div>
                  <div class="col-md-12 my-2">
                    <p class="h5">Notes</p>

                    <div
                      class="card bg-default"
                      v-for="comment in auth_code.comments"
                      v-bind:key="comment.id"
                    >
                      <div class="card-body">
                        <p class="">
                          {{ comment.body }}
                        </p>

                        <p class="text-xs">
                          {{
                            comment.created_at
                              | moment("dddd, MMMM Do YYYY,  h:mm:ss a")
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12 m-b-30">
                        <div class="card">
                          <div class="card-header border-bottom"></div>

                          <div class="card-footer row"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <div class="row col-md-12" v-if="auth_code">
                    <div class="col-md-6">
                      <button
                        v-if="
                          (auth_code.status != 'approved' &&
                            user.type == 'employee') ||
                          user.type == 'shis'
                        "
                        class="btn btn-success btn-block"
                        @click="generateCode(auth_code)"
                      >
                        Approve
                      </button>
                    </div>

                    <div class="col-md-6">
                      <button
                        v-if="
                          auth_code.status != 'approved' &&
                          auth_code.status != 'rejected' &&
                          (user.type == 'employee' || user.type == 'shis')
                        "
                        class="btn btn-danger btn-block"
                        @click="rejectRef(auth_code)"
                      >
                        Decline
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--End of Modal -->

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="spinner"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      user: null,
      showadder: false,
      userDetails: false,
      statuses: ["pending", "approved", "rejected"],
      states: [
        {
          state_id: 2669,
          name: "Kogi State (KGSHIA)",
          agency_id: 90,
        },
        {
          state_id: 2676,
          name: "Osun State (OSHIA)",
          agency_id: 95930,
        },
        {
          state_id: 2679,
          name: "Rivers State (RIVCHPP)",
          agency_id: 407465,
        },
        {
          state_id: 2679,
          name: "Zamfara State (ZAMCHEMA)",
          agency_id: 4,
        },
      ],
      json_fields: {
        "Date Requested": "created_at",
        "Auth Code": "code_created",
        "Code Usage": "code_usage",
        "Primary Diagnosis": "encounter.diagnosis.name",
        "Enrollee SHIA Number": "enrollee.id_card_number",
        "Intra Referral": "intra_referral",
        "Secondary Facility": "recipientfacility.agency_name",
      },
      auth_code: null,
      query: {
        state: "",
        provider_id: "",
        status: "",
        from: "",
        to: "",
        paginate_value: "",
      },
      codes: "",

      rows: "1",
      perPage: 15,
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    getCode(corridor) {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/single_authorization_code/${corridor.id}`)
        .then((response) => {
          this.auth_code = response.data;

          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    getCodes(currentPage) {
      this.getCodesAgency(currentPage);
    },

    getCodesAgency(currentPage) {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/authorization_code/95930`, {
          params: {
            is_corridor: 1,
            page: currentPage,
            state: this.query.state.state_id,
            status: this.query.status,
            paginate_value: this.query.paginate_value,
            from: this.query.from,
            to: this.query.to,
          },
        })
        .then((response) => {
          this.codes = response.data;
          this.isLoading = false;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    generateCode(auth_code) {
      if (confirm("Are you sure you want to Approve?")) {
        this.axios
          .post(`/api/v1/auth/generateCode`, {
            id: auth_code.id,
            expiry_days: 2,
          })
          .then((response) => {
            this.getCode(auth_code);
            console.log(response);
            this.$toasted.info("Generated Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    rejectRef(auth_code) {
      if (confirm("Are you sure you want to reject this request?")) {
        this.axios
          .post(`/api/v1/auth/updateCodeRequestStatus`, {
            id: auth_code.id,
            status: "rejected",
          })
          .then((response) => {
            console.log(response);
            this.show = true;
            this.getCode(auth_code);
            this.$toasted.info("Rejected Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          });
      }
    },
  },
  created() {
    this.getCodes();
  },
};
</script>
  